import {NgModule, APP_INITIALIZER, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient, HttpBackend} from '@angular/common/http';
import {WebConfigurationService} from './web-configuration.service';

export function createNonInterceptedHttpClient(httpBackend: HttpBackend): WebConfigurationService {
  const configService = new WebConfigurationService(new HttpClient(httpBackend));
  return configService;
}

export function configurationServiceInitializer(configurationService: WebConfigurationService) {
  return (): Promise<any> => {
    return configurationService.loadConfiguration();
  };
}

@NgModule({
  imports: [
    CommonModule
  ]
})
export class WebConfigurationModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WebConfigurationModule,
      providers: [
        {provide: WebConfigurationService, useFactory: createNonInterceptedHttpClient, deps: [HttpBackend]},
        {provide: APP_INITIALIZER, useFactory: configurationServiceInitializer, deps: [WebConfigurationService], multi: true}
      ]
    };
  }
}

export {WebConfigurationService} from './web-configuration.service';
export {WebConfiguration} from './web-configuration';
